"use strict";
import BrokeredCarriersStore from "../stores/brokered_carriers_store";
var BrokeredCarriersService = function() {
  var store = BrokeredCarriersStore;
  this.search = (term) => $.get(
    "/api/brokered_carriers",
    {
      page: 1,
      term
    }
  ).then(
    (data) => data.brokered_carriers,
    _.identity()
  );
};
var brokeredCarriersService = new BrokeredCarriersService();
export default brokeredCarriersService;
